import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import { api } from '../../app/Api/ApiSlice'
import InfiniteScroll from 'react-infinite-scroll-component'
import SuggestedBranchCard from '../../components/SuggestedBranchCard'
import { FaSearch } from 'react-icons/fa'
import { debounce } from 'lodash' // Highly recommended: npm install lodash

const BranchesSuggested = () => {
    const [suggestedBranches, setSuggestedBranches] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [searchedTerm, setSearchedTerm] = useState("")
    const [hasMore, setHasMore] = useState(true)

    const { organization } = useParams()
    const PAGE_LIMIT = 20; // Set your actual backend limit here

    const getSuggestedBranches = async (currentPage, searchTerm, isRefresh = false) => {
        try {
            setIsLoading(true)
            const response = await api.get(
                `/${organization}/branches/suggested`,
                { params: { page: currentPage, search: searchTerm } }
            )

            const newData = response.data || []

            setSuggestedBranches(prev => 
                currentPage === 1 ? newData : [...prev, ...newData]
            )

            // If we received fewer items than the limit, there are no more pages
            setHasMore(newData.length === PAGE_LIMIT)

        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to load branches")
        } finally {
            setIsLoading(false)
        }
    }

    // Handle Search with Debounce to prevent API spam
    const debouncedSearch = useCallback(
        debounce((term) => {
            setPage(1);
            getSuggestedBranches(1, term);
        }, 500),
        [organization]
    );

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchedTerm(value);
        debouncedSearch(value);
    };

    // Initial load and page changes
    useEffect(() => {
        if (page > 1) {
            getSuggestedBranches(page, searchedTerm);
        } else {
            // This handles the very first load
            getSuggestedBranches(1, searchedTerm);
        }
    }, [page]);

    const fetchNext = () => {
        if (!isLoading && hasMore) {
            setPage(prev => prev + 1)
        }
    }

    const handleRefresh = () => {
        setPage(1)
        getSuggestedBranches(1, searchedTerm)
    }

    return (
        <div>
            <h2 className='page-header-title'>Suggested Parents</h2>
            <div className="search-orgs">
                <div className="search-input-wrapper" style={{ position: 'relative',display:"flex" }}>
                    <input
                        type="search"
                        // className='org-search'
                        placeholder="Search branches..."
                        value={searchedTerm}
                        onChange={handleSearchChange}
                    />
                    <button><FaSearch /></button>
                </div>
            </div>

            <InfiniteScroll
                dataLength={suggestedBranches.length}
                next={fetchNext}
                hasMore={hasMore}
                loader={<Loader />}
                refreshFunction={handleRefresh}
                pullDownToRefresh={true}
                endMessage={
                    <p style={{ textAlign: 'center' }}>
                        <b>You have seen all branches</b>
                    </p>
                }
            >
                <div className="branches-grid">
                    {suggestedBranches.map((b) => (
                        <div className="add-branch-container" key={b._id}>
                            <SuggestedBranchCard b={b} />
                        </div>
                    ))}
                </div>
            </InfiniteScroll>
        </div>
    )
}

export default BranchesSuggested